import axios from '../helpers/axios'
import { logError } from '../services';
import { ISubcontractorTypeRes, ISubcontractorTypeUpdate, ISubcontractorType } from '../models';

export const getAdminSubcontractorsTypes = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  name?: string;
}): Promise<ISubcontractorTypeRes> => {
  try {
    const { data } = await axios.get(`/api/subcontractors/types`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getSubcontractorsTypes failed');
    return Promise.reject(error);
  }
};

export const getSubcontractorsTypes = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  name?: string;
}): Promise<ISubcontractorTypeRes> => {
  try {
    const { data } = await axios.get(`/api/subcontractors/common/types`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getSubcontractorsTypes failed');
    return Promise.reject(error);
  }
};

export const createSubcontractorType = async (order: ISubcontractorTypeUpdate): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/subcontractors/types`, order, { headers: { 'Content-Type': 'application/json' } });
    return data;
  } catch (error) {
    logError({ error, payload: order }, 'createSubcontractorType failed');
    return error.response.data;
  }
};

export const getSubcontractorType = async (id: number): Promise<ISubcontractorType> => {
  try {
    const { data } = await axios.get(`/api/subcontractors/types/${id}`);
    return data;
  } catch (error) {
    logError(error, 'getSubcontractorType failed');
    return Promise.reject(error);
  }
};

export const updateSubcontractorType = async (id: number, order: ISubcontractorTypeUpdate): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/subcontractors/types/${id}`, order, { headers: { 'Content-Type': 'application/json' } });
    return data;
  } catch (error) {
    logError({ error, payload: { id, order } }, 'updateSubcontractorType failed');
    return Promise.reject(error);
  }
};

export const deleteSubcontractorType = async (id: number): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/subcontractors/types/${id}`);
    return data;
  } catch (error) {
    logError(error, 'deleteSubcontractorType failed');
    return Promise.reject(error);
  }
};
